module.exports = __webpack_public_path__ + "img/OIP-3824180929.b62dbad9.jpg";